import { useEffect, useState } from "react";

/**
 * Returns true when the <html> element carries the `dark` class (the
 * mechanism this app uses for dark mode). Subscribes to class changes
 * so the value updates live when the user toggles theme in Settings.
 *
 * Shared between AppleSignInButton and the Google button wiring on
 * LoginPage so both buttons stay visually in sync.
 */
export const useIsDarkMode = () => {
  const [isDark, setIsDark] = useState(() => {
    if (typeof document === "undefined") return false;
    return document.documentElement.classList.contains("dark");
  });
  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    const target = document.documentElement;
    const observer = new MutationObserver(() => {
      setIsDark(target.classList.contains("dark"));
    });
    observer.observe(target, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);
  return isDark;
};
